import { render, staticRenderFns } from "./DialogConfirmDraft.vue?vue&type=template&id=a9bef556&scoped=true&"
import script from "./DialogConfirmDraft.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmDraft.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmDraft.vue?vue&type=style&index=0&id=a9bef556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bef556",
  null
  
)

export default component.exports